export const OPEN_MODAL = 'OPEN_MODAL'
export const OPEN_ITEM = 'OPEN_ITEM'